/** @jsxImportSource @emotion/react */
/* eslint-disable react/jsx-props-no-spreading */
import { cloneElement, useMemo, useState } from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import { usePopper } from "react-popper";
import ROOT from "constants/app-root";
import { arrowCss, popperCss, popperTextCss } from "./index.css";

export default function Popper({ children, text, placement, className }) {
  const [referenceElement, setReferenceElement] = useState(null);
  const [popperElement, setPopperElement] = useState(null);
  const [arrowElement, setArrowElement] = useState(null);
  const [showPopper, toggleShowPopper] = useState(false);

  const { attributes, styles } = usePopper(referenceElement, popperElement, {
    modifiers: [
      {
        name: "arrow",
        options: {
          element: arrowElement,
        },
      },
      {
        name: "offset",
        options: {
          offset: [0, 10],
        },
      },
    ],
    placement,
  });

  const clonedElement = useMemo(
    () =>
      cloneElement(children, {
        ref: setReferenceElement,
        onMouseEnter: () => setTimeout(() => toggleShowPopper(true), 300),
        onMouseLeave: () => setTimeout(() => toggleShowPopper(false), 300),
      }),
    [children],
  );

  return (
    <>
      {clonedElement}
      {showPopper &&
        ReactDOM.createPortal(
          <div
            css={popperCss}
            style={styles.popper}
            className={className}
            ref={setPopperElement}
            {...attributes.popper}
          >
            <div css={popperTextCss}>{text}</div>

            <div css={arrowCss} ref={setArrowElement} style={styles.arrow} />
          </div>,
          document.getElementById(ROOT),
        )}
    </>
  );
}

Popper.propTypes = {
  children: PropTypes.node.isRequired,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  className: PropTypes.string,
  placement: PropTypes.oneOf(["bottom", "top", "left", "right"]),
};
